export function contactAction(data){
  console.log(data);
  return {
       type:'ADD_POST',
  }
}
